import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import SearchIcon from '@material-ui/icons/Search'
import { t as i18n } from 'ttag'

const useStyles = makeStyles(theme => ({
  root: {
    alignItems: 'center',
    display: 'inline'
  },
  iconButton: {
    padding: theme.spacing(1)
  },
  button: {
    padding: theme.spacing(2, 3)
  }
}))

const SearchBtn = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Button
        className={classes.button}
        variant='contained'
        color='primary'
        size='large'
        startIcon={<SearchIcon />}
      >
        {i18n`Search`}
      </Button>
    </div>
  )
}

export default SearchBtn
